import { lang } from "moment";

window.CampaignForm = {

	structure : {
		campaignID	: null,
		settings	: {},
		blocks		: {}
	},

	init : function(data){
		MyTabs.initHorizontal('campaignEditorForm');

		var formID		= "campaignEditorForm";
		var formData	= {action : 'recordCampaign'};

		CampaignForm.structure.campaignID = $('input[name=campaign_id]').val();

		switch($('#campaign_editMode').val()){
			case 'html' :
				MyTabs.initHorizontal('campaignEditorForm');
				// HTML EDITOR
				var codeMirrorOpts = {
					mode			: 'text/html',
					lineNumbers		: true,
					indentWithTabs	: true,
					autoCloseTags	: true,
					placeholder		: Loc.g('Copiez / Collez le code de votre email ici...'),
					onChange		: function(cm) {
						cm.save();
					}
				};

				var doc = document.getElementById('emailPreview').contentWindow.document;
				doc.open();
				doc.write(window.document.getElementById('contentHtml').value);
				doc.close();

				var myCodeMirror = CodeMirror.fromTextArea(window.document.getElementById('contentHtml'), codeMirrorOpts);

				myCodeMirror.on('change',function(cMirror){
					// get value right from instance
					var contentHTML = cMirror.getValue();

					contentHTML = contentHTML.replace('<script>', '');

					window.document.getElementById('contentHtml').value = contentHTML;

					var doc = document.getElementById('emailPreview').contentWindow.document;
					doc.open();
					doc.write(contentHTML);
					doc.close();
				 });

				break;
			case 'editor' :
				var existingStructure = $('#structure').html();
				if(existingStructure.length > 0){
					CampaignForm.structure = JSON.parse($('textarea#structure').val());
				}
				CampaignForm.structure.campaignID = $('input[name=campaign_id]').val();

				window.onload = function() {
					$("#emailPreview").ready(function () {


						var iframeContent = $("#emailPreview").contents();

						iframeContent.find('a:not(.options a)').unbind('click').on('click', function(){
							window.parent.window.open($(this).attr('href'));
							return false;
						});

						iframeContent.find("#drop-area").sortable({
                            items		: '.emailBlock',
                            axis		: 'y',
                            handle		: '.handler',
                            placeholder : 'emailBlock-placeholder',
                            zIndex		: 10000,
						// containment : "#drop-area",
						// iframeFix	: true,
                            start		: function(e, ui ){
                                ui.placeholder.height(ui.helper.outerHeight());
                                ui.placeholder.html('<div style="text-align:center;z-index:1000">'+Loc.g('Déposer le bloc ici')+'</div>');
                            },
                            receive : function(event, ui) {

                                var block = {};
                                $("#emailPreview").contents().find('.emailBlockPlaceholder').fadeOut('fast');

                                block.id	= Math.ceil(Math.random() * 10000);
                                block.type	= ui.item.find('input[name=template]').val();

                                block.data = {};

                                switch(block.type){
                                    case 'text-1col' :
                                        block.data = {
                                            textblock	: ui.item.find('.textblock').html().trim(),
                                            padding		: 10
                                        };
                                        break;
                                    case 'text-2col' :
                                        block.data = {
                                            textblock	: ui.item.find('.textblock').html().trim(),
                                            textblock2	: ui.item.find('.textblock2').html().trim(),
                                            padding		: 10
                                        };
                                        break;
                                    case 'button' :
                                        block.data = {
                                            label	: ui.item.find('.label').html().trim(),
                                            padding		: 10
                                        };
                                        break;
                                    case 'image' :
                                        block.data = {
                                            imagetype	: 'link',
                                            url			: '/ressources/logged/img/placeholder/placeholder_750x150.png',
                                            padding		: 0,
                                        };
                                        break;
                                    case 'imagetext' :
                                        block.data = {
                                            textblock	: ui.item.find('.textblock').html().trim(),
                                            imagetype	: 'link',
                                            url			: '/ressources/logged/img/placeholder/placeholder_375x150.png',
                                            padding		: 10
                                        };
                                        break;
                                }
                                CampaignForm.structure.blocks[block.id] = block;

                                var $element = $('<div class="emailBlock '+ui.item.attr('id')+'" id="block-'+block.id+'">'+ ui.item.find('.elementBlock').html() + '</div>'); //   onclick="window.parent.CampaignForm.blockSettings('+block.id+');"
                                $element.find('.editBtn').attr('onclick', 'window.parent.CampaignForm.blockSettings('+block.id+');');
                                $element.find('.deleteBtn').attr('onclick', 'window.parent.CampaignForm.deleteBlock('+block.id+');');
                                $element.find('.options').removeAttr('style');
                                $element.removeAttr('style');


                                $(this).data().uiSortable.currentItem.replaceWith($element);

                                CampaignForm.blockSettings(block.id);
                            },

                            update : function(event, ui){
                                var sortRes =  $(this).sortable('toArray');
                                var newStructure = {};

                                for(var cpt in sortRes){
                                    var blockParts = sortRes[cpt].split('-');
                                    if(blockParts[1] != undefined && CampaignForm.structure.blocks[blockParts[1]] != undefined){
                                        CampaignForm.structure.blocks[blockParts[1]].rank = cpt;
                                        newStructure[blockParts[1]] = CampaignForm.structure.blocks[blockParts[1]];
                                    }
                                }
                                CampaignForm.structure.blocks = newStructure;
                            }
                        });

                        $(".available-block").draggable({
//						appendTo			: 'body',
                            helper				: "clone",
                            revert				: 'invalid',
                            cursor				: 'pointer',
//						cursorAt			: {left : 0, top:0},
                            opacity				: 1,
                            revertDuration		: 200,
                            zIndex				: 10001,
                            connectToSortable	: iframeContent.find("#drop-area"),
                            scroll				: true,
                            iframeFix			: true, //Core jquery ui params needs for fix iframe bug
                            iframeOffset		: iframeContent.find("#drop-area").offset(),
                            iframeScroll		: true, //This param needs for activate iframeScroll
                            scrollSensitivity	: 20,
                            tolerance			: 'pointer',
                            refreshPositions	: true,
                            drag				: function(event, ui){

                                if(ui.helper.closest('body').attr('id') === 'iframeemail'){

                                    var iframeOffset = $("#emailPreview").offset();
                                    ui.position.top		-= iframeOffset.top;
                                    ui.position.top		+= $("#emailPreview").contents().scrollTop();
                                    ui.position.left	-= iframeOffset.left ;

                                }
                            }
                        });
                    });

//					iframeContent.find("#drop-area").disableSelection();

					$('.globalColorpicker').colpick({
						layout		: 'hex',
						submit		: 0,
						colorScheme	: 'light',
						onChange	: function(hsb, hex, rgb, el, bySetColor) {

							$(el).parent().find('.append').css('background-color','#'+hex);
							// Fill the text box just if the color was set using the picker, and not the colpickSetColor function.
							$(el).val(hex);
							CampaignForm.structure[$(el).attr('name')] = hex;

							switch($(el).attr('name')){
								case "bodyBackground" :
									$("#emailPreview").contents().find('body').css('background-color', '#'+hex);
									break;
								case "contentBackground" :
									$("#emailPreview").contents().find('#content').css('background-color', '#'+hex);
									break;
							}
						}
					}).unbind('keyup').keyup(function(){
						$(this).colpickSetColor(this.value);
					}).trigger('keyup');


				};

				break;
		}
		 // -----

		var options = {
			data : formData,
			dataType : 'json',
			beforeSend : function(jqXHR, settings){
				if($('#campaign_editMode').val() == 'editor'){

					var tabStructure = $.makeArray(CampaignForm.structure);
					settings.data += "&"+$.param({structure : tabStructure[0]});
				}
			},
			success : function(data){
				var formOk = MyForm.processJson(data, formID);
				MyFacture.stopWait();
				if(!formOk){
					var errors = [];

					for (var i in data.form.fields){
						if(data.form.fields[i].status != 'ok'){
							errors.push('<li>'+data.form.fields[i].msg+'</li>');
						}
					}

					if(errors.length > 0){
						MyWindow.alert('<ul>'+errors.join("\n")+'</ul>', {type : 'error'});
					}

					/**
					 * @todo : callback to overview (or not!)
					 */
				}
			}
		};

		MyForm.prepare(formID, 'massmailing_campaignForm', options, true);

        setTimeout(function(){
            MyFacture.stopWait();
        }, 1500);

	},

	recordIt : function(callbackAction){
		$('#campaignEditorForm').find('input[name=callbackAction]').val(callbackAction);
		MyFacture.startWait();
		$('#campaignEditorForm').submit();
	},


	getEmailText : function(){
		var doc = document.getElementById('emailPreview').contentWindow.document;

		var $emailContent		= $(doc);
		var contentText			= $emailContent.find('body').text().trim();
		var contentTextParts	= contentText.split("\n");
		var recomposedText		= '';

		for(var cpt = 0; cpt < contentTextParts.length; cpt++){

			var trimmed = contentTextParts[cpt].trim();

			if(trimmed != ''){
				recomposedText += trimmed+"\n";
			}
		}

		$("#contentText").val(recomposedText);
	},


	blockSettings : function(blockID){

		if(CampaignForm.structure.blocks[blockID] == undefined){
			return false;
		}

		var block = CampaignForm.structure.blocks[blockID];

		var $blockContainer = $('.blockEditor');
		$blockContainer.empty().hide();

		MyFacture.post('massmailing_campaignForm', {action : 'templateForm', blockID : block.id, type : block.type}, function(data){
			var $blockForm = $(data.form);

			for(var cpt in block.data){
				var content	= block.data[cpt];
				var $input	= $blockForm.find(':input[name='+cpt+']');

				if($input.hasClass('redactor')){
					$input.html(content);
				}else{
					$input.val(content);
				}
			}

			$blockContainer.closest('.content-block').find('.placeholder').hide();
			$blockForm.appendTo('.blockEditor');
			$blockContainer.fadeIn('fast');


			var redactorOpts = {
				changeCallback: function(content){
					var blockID		= $(this)[0].$element.closest('form').find('input[name=blockID]').val();
					var textBlock	= $(this)[0].$element.attr('name');
					var block		= CampaignForm.structure.blocks[blockID];

					var carriageReg = new RegExp("\n|\r|\t", 'g');
					content = content.replace(carriageReg, "");

					$("#emailPreview").contents().find('#block-'+blockID+" ."+textBlock).html(content.trim());
					block.data[textBlock] = content.trim();
				},
				minHeight : 150,
				shortcuts : false,

				tidyHtml : false,
				removeEmptyTags : false,
				linebreaks : true,
				lang : window.App.lang,

				buttons : [
					'html', '|', 'formatting', '|', 'bold', 'italic', 'underline', 'deleted', '|',
					'unorderedlist', 'orderedlist', 'indent', 'outdent', '|',
					'image', 'table', 'link', '|', 'alignment', '|', 'horizontalrule'
				],
				plugins : ['fontsize', 'fontfamily', 'fontcolor', 'massmailingTags']
			};


			$('.redactor').redactor(redactorOpts);

			// ColorPicker
			$('.colorpicker').colpick({
				layout:'hex',
				submit:0,
				colorScheme:'light',
				onChange:function(hsb, hex, rgb, el, bySetColor) {
					var blockID		= $(el).closest('form').find('input[name=blockID]').val();

					$(el).parent().find('.append').css('background-color','#'+hex);
					// Fill the text box just if the color was set using the picker, and not the colpickSetColor function.
					$(el).val(hex);
					CampaignForm.structure.blocks[blockID].data[$(el).attr('name')] = hex;

					switch($(el).attr('name')){
						case "backgroundcolor" :
							$("#emailPreview").contents().find('#block-'+blockID+' td').css('background-color', '#'+hex);
							break;
						case "textcolor" :
							$("#emailPreview").contents().find('#block-'+blockID+' td').css('color', '#'+hex);
							// $("#emailPreview").contents().find('#block-'+blockID+' td *').css('color', '#'+hex+" !important");
							break;
						case "buttonbackground" :
							$("#emailPreview").contents().find('#block-'+blockID+' a.buttonurl').css('background-color', '#'+hex);
							break;
						case "buttoncolor" :
							$("#emailPreview").contents().find('#block-'+blockID+' a.buttonurl .label').css('color', '#'+hex+"");
							break;
					}
				}
			}).unbind('keyup').keyup(function(){
				$(this).colpickSetColor(this.value);
			}).trigger('keyup');

			$('.blockEditor form').unbind('submit').bind('submit', function(){
				$blockContainer.fadeOut('fast', function(){
					$(this).closest('.content-block').find('.placeholder').fadeIn('fast');
				});
				return false;
			});

			MyFacture.customForm('#emailBlockForm');
		}, 'json');

	},


	deleteBlock : function(blockID){

		var $blockContainer =  $('.blockEditor');
		var options = {
			type : 'warning',
			buttons : [
				{
					text : Loc.g('Non'),
					click : function(){$(this).dialog('close');}
				},
				{
					text : Loc.g('Oui'),
					click : function(){
						$(this).dialog('close');
						delete CampaignForm.structure.blocks[blockID];

						if($blockContainer.find('input[name=blockID]').val() == blockID){
							$blockContainer.fadeOut('fast', function(){
								$(this).empty();
								$blockContainer.closest('.content-block').find('.placeholder').fadeIn('fast');
							});
						}

						$("#emailPreview").contents().find('#block-'+blockID).slideUp(400, function(){
							$(this).remove();

							if($("#emailPreview").contents().find('.emailBlock').length == 0){
								$('#emailPreview').contents().find('.emailBlockPlaceholder').fadeIn('fast');
							}
						});

					}
				}
			]
		};

		MyWindow.alert(Loc.g("Supprimer ce bloc de l'email ?"), options);
	},


	updateText : function(elt, type){
		type			= type === undefined ? '' : type;
		var blockID		= $(elt).closest('form').find('input[name=blockID]').val();
		var name		= $(elt).attr('name');
		var text		= $(elt).val().trim();

		switch(type){
			case 'alt' :
				CampaignForm.structure.blocks[blockID].data[name] = text;
				$("#emailPreview").contents().find('#block-'+blockID+" img").attr('alt', text);
				break;
			default :
				CampaignForm.structure.blocks[blockID].data[name] = text;
				$("#emailPreview").contents().find('#block-'+blockID+" ."+name).text(text);
				break;
		}
	},

	updateURL : function(elt){
		var blockID		= $(elt).closest('form').find('input[name=blockID]').val();
		var name		= $(elt).attr('name');
		var text		= $(elt).val().trim();

		CampaignForm.structure.blocks[blockID].data[name] = text;
		$("#emailPreview").contents().find('#block-'+blockID+" a."+name).attr('href', text);
	},

	updateImage : function(elt){
		var blockID	= $(elt).closest('form').find('input[name=blockID]').val();
		var formID	= 'imageForm';

		var imageData = {'image' : CampaignForm.structure.blocks[blockID].data};
		var data = $.extend(imageData, {action : 'imageForm', campaignid : CampaignForm.structure.campaignID});

		var options = {
			title :  Loc.g('Choisir une image'),
			buttons: [
				{
					text: Loc.g("Annuler"),
					click: function() {
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Enregistrer"),
					click: function() {
						$("#" + formID).submit();
					}
				}
			],
			width: 980,
			callback : function(){
				$('.file-selector .nano').nanoScroller({preventPageScrolling: true});

				var formOpts = {
					data		: {action : 'recordImage', blockID : blockID},
					dataType	: 'json',
					success		: function(data){

						var formOK = MyForm.processJson(data, formID);
						if(formOK){

							switch(data.image.imageType){
								case 'link' :
									CampaignForm.structure.blocks[blockID].data['imagetype']	= data.image.imageType;
									CampaignForm.structure.blocks[blockID].data['url']			= data.image.url;

									$("#emailPreview").contents().find('#block-'+blockID+" img").attr('src', data.image.url);
									break;
								case 'briefcase' :
									CampaignForm.structure.blocks[blockID].data['imagetype']	= data.image.imageType;
									CampaignForm.structure.blocks[blockID].data['fileid']		= data.image.fileid;
									CampaignForm.structure.blocks[blockID].data['url']			= data.image.url;

									$("#emailPreview").contents().find('#block-'+blockID+" img").attr('src', data.image.url);

									break;
							}

							MyWindow.close();
						}

					}
				};

				MyForm.prepare(formID, 'massmailing_campaignForm', formOpts, true);
			}
		};

		MyWindow.load('massmailing_campaignForm', data, options);
	},

	selectBriefcaseImage : function(fileID){
		$('#imageForm').find('input[name=fileid]').val(fileID);
		$('#imageForm').find('.chosen-filename').val($('#file-'+fileID).find('.filename').text());

		$('.fileslist li:not(#file_'+fileID+')').removeClass('file-selected');
		$('#file_'+fileID).addClass('file-selected');
    },

    deleteBriefcaseImage: function(fileID){
        return BriefCaseV2Light.deleteIt(fileID)
        .then(() => {
            if ($('#imageForm').find('input[name=fileid]').val() != fileID) {
                return;
            }
            CampaignForm.selectBriefcaseImage(0)
        }).catch(e => {});
    },

	foldToggle : function(elt){
		$(elt).find('i').toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
		$(elt).closest('.folder').find('.fileslist').slideToggle(300);
	},


	updateTextAlign : function(elt){
		var blockID		= $(elt).closest('form').find('input[name=blockID]').val();
		var name		= $(elt).attr('name');
		var value		= $(elt).val();

		CampaignForm.structure.blocks[blockID].data[name] = value;

		var $block = $("#emailPreview").contents().find('#block-'+blockID);
		switch(CampaignForm.structure.blocks[blockID].type) {
			case 'image' :
				if(value === 'center') {
					$block.find('img').css('float', 'none').css('display', 'inline').closest('td').css('text-align', 'center');
				} else {
					$block.find('img').css('float', value);
				}
				break;
			default :
				$block.find('td').css('text-align', value);
				break;
		}
	},

	updatePadding : function(elt){
		var blockID		= $(elt).closest('form').find('input[name=blockID]').val();
		var name		= $(elt).attr('name');
		var value		= $(elt).val();

		CampaignForm.structure.blocks[blockID].data[name] = value;

		var $block = $("#emailPreview").contents().find('#block-'+blockID);

        if (name == "padding-x") {
            $block.find('.textblock, .textblock2, .imageblock').css({
                'padding-left' : value+'px',
                'padding-right': value+'px'
            });
        }
        else if (name == "padding-y") {
            $block.find('.textblock, .textblock2, .imageblock').css({
                'padding-top' 	: value+'px',
                'padding-bottom': value+'px'
			});
        }
	},

	changeImagePosition : function(elt){
		var blockID		= $(elt).closest('form').find('input[name=blockID]').val();
		var name		= $(elt).attr('name');
		var value		= $(elt).val();

		CampaignForm.structure.blocks[blockID].data[name] = value;

		var $block = $("#emailPreview").contents().find('#block-'+blockID);
		switch(CampaignForm.structure.blocks[blockID].type){
			case 'imagetext' :
				var $imgBlock = $block.find('.imageblock');
				$block.find('.imageblock').remove();
				if(value == 'left'){
					$imgBlock.insertBefore($block.find('.textblock'));
				}else if(value == 'right'){
					$imgBlock.insertAfter($block.find('.textblock'));
				}
				break;
		}
	},


	addImage : function(imageData, campaignID){
		$.ajax({
			url			: '/?_f=imagePicker',
			data		: {action : 'loadBriefcase', linkedtype : 'massmailing', linkedid : campaignID},
			dataType	: 'json',
			success		: function(data){
				$('#briefcaseContent').empty();
				$('#briefcaseContent').html(data.briefcase);


				if(imageData.file_infos.file_id != undefined){
					CampaignForm.selectBriefcaseImage(imageData.file_infos.file_id);
				}
			}
		});
	}
};
